<template>
    <div v-if="projeto" class="modal-overlay" @click="$emit('fechar')">
        <div class="modal-conteudo modal-grande" @click.stop>
            <div class="modal-header">
                <h3>Tarefas: {{ projeto.nome }}</h3>
                <button class="btn-fechar-modal" @click="$emit('fechar')">×</button>
            </div>
            <div class="modal-body">
                <div class="tarefas-grid">
                    <div v-if="projeto.entregas && projeto.entregas.length > 0">
                        <div v-for="entrega in projeto.entregas" :key="entrega.id" class="entrega-section">
                            <h4>{{ entrega.nome }}</h4>
                            <div v-if="entrega.sprints && entrega.sprints.length > 0">
                                <div v-for="sprint in entrega.sprints" :key="sprint.id" class="sprint-section">
                                    <h5>Sprint: {{ sprint.nome }}</h5>
                                    <table class="tabela-pequena">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Descrição</th>
                                                <th>Responsável</th>
                                                <th>HP</th>
                                                <th>Status</th>
                                                <th>Prazo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="t in sprint.tarefas" :key="t.id" :class="{ 'tarefa-atrasada': isTarefaAtrasada(t) }">
                                                <td>{{ t.codigo ?? '-' }}</td>
                                                <td>{{ t.descricao ?? '-' }}</td>
                                                <td>{{ t.responsavel?.name ?? '-' }}</td>
                                                <td>{{ t.HP ?? '-' }}</td>
                                                <td>
                                                    <span class="chip chip-pequeno" :class="getStatusClass(t.status)">{{ t.status ?? '-' }}</span>
                                                </td>
                                                <td>
                                                    <span v-if="t.dtFim">
                                                        <span v-if="isTarefaAtrasada(t)" class="txt-erro">
                                                            {{ formatarData(t.dtFim) }} (atrasada)
                                                        </span>
                                                        <span v-else>{{ formatarData(t.dtFim) }}</span>
                                                    </span>
                                                    <span v-else>-</span>
                                                </td>
                                            </tr>
                                            <tr v-if="!sprint.tarefas || sprint.tarefas.length === 0">
                                                <td colspan="6" class="text-center txt-secundario">Nenhuma tarefa cadastrada</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="sem-dados">Nenhuma sprint cadastrada neste pacote de trabalho</div>
                        </div>
                    </div>
                    <div v-else class="sem-dados">Nenhum pacote de trabalho cadastrado no projeto</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalDetalhesTarefas',
    props: {
        projeto: {
            type: Object,
            default: null
        }
    },
    emits: ['fechar'],
    methods: {
        formatarData(data) {
            if (!data) return '-';
            return new Date(data).toLocaleDateString('pt-BR');
        },
        getStatusClass(status) {
            if (!status) return '';
            const statusLower = status.toLowerCase();
            if (statusLower.includes('concluído') || statusLower.includes('concluido')) return 'bg-sucesso';
            if (statusLower.includes('andamento')) return 'bg-info';
            if (statusLower.includes('pendente')) return 'bg-alerta';
            if (statusLower.includes('cancelado') || statusLower.includes('cancelada')) return 'bg-secundario';
            return '';
        },
        isTarefaAtrasada(tarefa) {
            if (tarefa.status === 'Concluído' || tarefa.status === 'Cancelada' || !tarefa.dtFim) return false;
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            const dtFimTarefa = new Date(tarefa.dtFim);
            dtFimTarefa.setHours(0, 0, 0, 0);
            return dtFimTarefa < hoje;
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 2rem;
}

.modal-conteudo {
    background: white;
    border-radius: 8px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-conteudo.modal-grande {
    max-width: 1200px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #eee;
}

.modal-header h3 {
    margin: 0;
}

.btn-fechar-modal {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: #999;
    line-height: 1;
    padding: 0;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-fechar-modal:hover {
    color: #333;
}

.modal-body {
    padding: 1.5rem;
}

.tarefas-grid {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.entrega-section {
    margin-bottom: 2rem;
}

.entrega-section h4 {
    margin-bottom: 1rem;
    color: var(--cor-primaria, #3697d3);
}

.sprint-section {
    margin-bottom: 1.5rem;
}

.sprint-section h5 {
    margin-bottom: 0.75rem;
    color: #666;
    font-size: 0.95rem;
}

.tabela-pequena {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

.tabela-pequena th {
    background: #f8f9fa;
    padding: 0.75rem;
    text-align: left;
    font-weight: 600;
    border-bottom: 2px solid #ddd;
}

.tabela-pequena td {
    padding: 0.75rem;
    border-bottom: 1px solid #eee;
}

.tarefa-atrasada {
    background: #fff5f5;
}

.text-center {
    text-align: center;
}

.sem-dados {
    text-align: center;
    color: #999;
    padding: 2rem;
}
</style>

